import classNames, { Argument as ClassNameArgument } from "classnames";
import React, { CSSProperties, FC } from "react";
import { styles } from "./link.scss";


export const Link: FC<{
    text?: string;
    url?: string;
    hint?: boolean | string;
    onClick?: () => void;
    className?: ClassNameArgument;
    style?: CSSProperties;
    children?: React.ReactNode;
}> =
    ({ text, url, hint, onClick, className, style, children }) =>
    {
        // url = url ?? "javascript:void";
        children = children ?? text;

        const local =
            !!url &&
            !url.includes("//") &&
            !url.includes(":");

        const $onClick: React.MouseEventHandler =
            (onClick || local)
                ? (
                    ev =>
                    {
                        ev.preventDefault();
                        onClick?.();
                        if (local)
                        {
                            window.history.pushState(null, null, url);
                            window.dispatchEvent(new HashChangeEvent("hashchange"));
                        }
                    }
                )
                : undefined;

        const title =
            (typeof hint == "boolean")
                ? text
                : hint;

        return (
            <a
                title={title}
                href={url}
                onClick={$onClick}
                className={classNames(styles.link, className)}
                style={style}
            >
                {children}
            </a>
        );
    };
